import type { $Fetch } from 'nitropack';
import type { BFFResponse } from '~/types/BFFResponse';
import type { Cart, Me, ShippingMethod } from '~/types/GraphQL';

export default ($fetch: $Fetch) => {
  const createCart = async () => $fetch<BFFResponse<unknown>>('/carts', { method: 'POST', body: {} });

  const addToCart = async (id: string, version: string, body: any) => $fetch<BFFResponse<Cart>>(`/carts/${id}/${version}/item`, { method: 'PUT', body });

  const checkCartVersion = async (id: string) => $fetch<BFFResponse<number>>(`/carts/check/${id}`);

  const deleteActiveCarts = async () => $fetch<BFFResponse<void>>(`/carts/active`, { method: 'DELETE' });

  const updateCart = async (id: string, version: string, body: any) => $fetch<BFFResponse<{ cart: Cart }>>(`/carts/${id}/${version}`, { method: 'PUT', body });

  const recalculateCart = async (cartKey: string) => $fetch<BFFResponse<{ cart: Cart; actions: {
    code: string;
    message: string;
    reference: string;
  }[]; }>>(`/carts/${cartKey}/recalculate`);

  const updateQty = async (id: string, version: string, body: any) => $fetch<BFFResponse<Cart>>(`/carts/${id}/${version}/quantity`, { method: 'PATCH', body });

  const removeItem = async (id: string, version: string, body: any) => $fetch<BFFResponse<Cart>>(`/carts/${id}/${version}/item`, { method: 'DELETE', body });

  const saveShippingMethod = async (id: string, version: string, body: any) => $fetch<BFFResponse<Me>>(`/carts/${id}/${version}/shippingMethod`, { method: 'PUT', body });

  const applyCoupon = async (id: string, version: string, body: any) => $fetch<BFFResponse<Cart>>(`/carts/${id}/${version}/promotion`, { method: 'PUT', body });

  const removeCoupon = async (id: string, version: string, body: any) => $fetch<BFFResponse<Cart>>(`/carts/${id}/${version}/promotion`, { method: 'DELETE', body });

  const removeLoyaltyCoupon = async (id: string, version: string) => $fetch<BFFResponse<Cart>>(`/carts/${id}/${version}/loyalty/promotion`, { method: 'DELETE' });

  const setNewsletterState = async (id: string, version: string, body: any) => $fetch<BFFResponse<unknown>>(`/carts/${id}/${version}/subscribeNewsletter`, { method: 'PUT', body });

  const getShippingMethodsByCart = async (id: string | undefined) => $fetch<BFFResponse<ShippingMethod[]>>(`/carts/${id}/shippingMethods`);

  const setPayment = async (id: string | undefined, version: string, orderNumber: string | undefined, body: any) => $fetch<BFFResponse<Cart>>(`/carts/${id}/${version}/order/${orderNumber}/payment`, { method: 'PUT', body });

  return {
    createCart,
    addToCart,
    checkCartVersion,
    deleteActiveCarts,
    updateCart,
    updateQty,
    removeItem,
    saveShippingMethod,
    applyCoupon,
    removeCoupon,
    recalculateCart,
    removeLoyaltyCoupon,
    setNewsletterState,
    getShippingMethodsByCart,
    setPayment,
  };
};
